import Address from '@modules/husleie-framework/src/types/Address.entity';
import { Tenant } from '@modules/husleie-framework/src/types/Tenant.entity';
import UserConversionOperations from '@modules/store/user/static-classes/UserConversionOperations';
import { UserTranslationOptions } from '@modules/store/user/types/UserTranslationOptions.entity';
import AddressStringOperations from '@modules/husleie-framework/src/static-classes/AddressStringOperations.class';

export default class TenantConversionOperations {
  static apiToInternal(apiTenant: any, options: UserTranslationOptions): Tenant {
    const tenant: Tenant = {};
    if (apiTenant) {
      tenant.id = apiTenant.id;
      tenant.type = apiTenant.type;
      tenant.status = apiTenant.status;
      tenant.user = UserConversionOperations.apiToInternal(apiTenant, { ...options, indirect: true });

      if (apiTenant.address) {
        const address: Address = {
          street: apiTenant.address.street,
          additionalAddress: apiTenant.address.street2,
          postalCode: apiTenant.address.postalCode,
          postalArea: apiTenant.address.postalArea,
          country: {
            code: apiTenant.address.countryCode,
          },
          fullAddress: AddressStringOperations.getNiceAddress(apiTenant.address),
        };
        tenant.address = address;
      }
    }

    return tenant;
  }

  static internalToApi(tenant: undefined | Tenant) {
    if (tenant) {
      const tenantAPI: any = { ...UserConversionOperations.internalToApi(tenant.user) };
      tenantAPI.type = tenant.type;
      tenantAPI.status = tenant.status;
      if (tenant.address) {
        const tenantAddressAPI: any = {
          street: tenant.address?.street,
          street2: tenant.address?.additionalAddress,
          postalCode: tenant.address?.postalCode,
          postalArea: tenant.address?.postalArea,
          countryCode: tenant.address?.country.code,
        };
        tenantAPI.address = tenantAddressAPI;
      }

      return tenantAPI;
    }

    return undefined;
  }
}
